module.exports = __webpack_public_path__ + "media/images/pic/teachers_number-6a0fe779cfde3207732c1edb5551dbc7.svg";